import React, { useRef } from 'react';
import { Card } from 'primereact/card';
import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import { Button } from 'primereact/button';
import {BASE_URL} from "../services/config";
import {useToast} from "../ToastProvider";

export default function LoginForm({ onLogin }) {
    const { addToast } = useToast();
    const [username, setUsername] = React.useState('');
    const [password, setPassword] = React.useState('');
    const toast = useRef(null);

    const handleLogin = async () => {
        try {
            const response = await fetch(`${BASE_URL}/auth/login`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ username, password }),
            });

            const data = await response.json();

            if (!response.ok) {
                addToast('Đăng nhập thất bại','error');
                return;
            }

            localStorage.setItem('accessToken', data.data.accessToken);
            localStorage.setItem('userName', data.data.owner.username);

            addToast('Đăng nhập thành công','success');
            onLogin(data);
        } catch (err) {
            addToast('Đăng nhập thất bại','error');
        }
    };

    return (
        <div className="flex justify-content-center align-items-center" style={{ height: '100vh' }}>
            <Card title="🚀 VDG Đăng nhập" style={{ width: 400 }}>
                <div className="p-fluid">
                    <div className="field">
                        <label htmlFor="username">Tài khoản</label>
                        <InputText id="username" value={username} onChange={(e) => setUsername(e.target.value)} />
                    </div>

                    <div className="field">
                        <label htmlFor="password">Mật khẩu</label>
                        <Password id="password" value={password} onChange={(e) => setPassword(e.target.value)} feedback={false} toggleMask />
                    </div>

                    <Button label="Đăng nhập" className="mt-3" onClick={handleLogin} icon="pi pi-sign-in" />
                </div>
            </Card>
        </div>
    );
}
